// Material helpers
import { createMuiTheme, createTheme } from '@material-ui/core';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const theme = createTheme({
  palette,
  typography,
  overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100
  },
  props: {
    // Name of the component ⚛️
    MuiButtonBase: {
      // The default props to change
      disableRipple: true, // No more ripple, on the whole application 💣!
      classes: {}
    },
    MuiInputLabel:{
                shrink: true,
                classes: {}
            },
    MuiFormLabel: {
        classes: {}
    },
    MuiInputBase: {
      classes: {
        error: 'error'
      }
    },
    MuiFormControl: {
      classes: {}
    },
    MuiTextField: {
      classes: {}
    },
    MuiButton: {
      classes: {}
    },
    MuiFormHelperText: {
      classes:{}
    }


  }
});

export default theme;